// Lightweight bottom toast shared by map modules (favorites, share).
// Styling lives in the existing `.nm-toast` CSS.

const TOAST_SHOW_DELAY_MS = 10;
const TOAST_VISIBLE_MS = 2400;
const TOAST_FADE_OUT_MS = 400;

export function showToast(msg) {
    const toast = document.createElement('div');
    toast.className = 'nm-toast';
    toast.setAttribute('role', 'status');
    toast.textContent = msg;
    document.body.appendChild(toast);
    setTimeout(function () { toast.classList.add('is-visible'); }, TOAST_SHOW_DELAY_MS);
    setTimeout(function () {
        toast.classList.remove('is-visible');
        setTimeout(function () { if (toast.parentNode) toast.parentNode.removeChild(toast); }, TOAST_FADE_OUT_MS);
    }, TOAST_VISIBLE_MS);
}
